import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getWorkEnvironmentSurveyById } from '../../api/workEnvironmentQueries';
import { WorkEnvironmentSurvey } from '../../api/workEnvironmentTypes';

export const WorkEnvironmentSurveyByIdQueryKey = 'WORK_ENVIRONMENT_SURVEY_BY_ID';

export const useGetWorkEnvironmentSurveyByIdQuery = (
  surveyId: number,
  options?: Omit<UseQueryOptions<WorkEnvironmentSurvey>, 'queryKey' | 'queryFn'>
) => {
  return useQuery({
    queryKey: [WorkEnvironmentSurveyByIdQueryKey, surveyId],
    queryFn: () => getWorkEnvironmentSurveyById(surveyId),
    ...options,
  });
};
